import React, { FC } from 'react';
import { Box, SubscriberStarIcon } from '@deckee/deck-hand';
import styled, { css } from 'styled-components';

interface BaseMapButtonProps {
  onClick: () => void;
  className?: string;
  active?: boolean;
  name: string;
  imageUrl: string;
  subscriberOnly: boolean;
}

interface StyledMapImageProps {
  $backgroundImage: string;
  $active: boolean;
}

const StyledMapImage = styled.div<StyledMapImageProps>`
  background-image: ${({ $backgroundImage }) => css`url(${$backgroundImage})`};
  background-repeat: no-repeat;
  background-size: cover;
  border: 2px solid
    ${({ theme, $active }) => ($active ? theme.colors.primary : 'white')};
  border-radius: 5px;
  width: 94px;
  height: 58px;
  position: relative;
  box-sizing: border-box;
`;

const BaseMapButton: FC<BaseMapButtonProps> = ({
  className,
  name,
  onClick,
  imageUrl,
  active,
  subscriberOnly,
}) => (
  <Box
    className={className}
    display="flex"
    flexDirection="column"
    alignItems="center"
    onClick={onClick}
  >
    <StyledMapImage $active={active || false} $backgroundImage={imageUrl}>
      {subscriberOnly && (
        <Box position="absolute" right="-10px" top="-10px">
          <SubscriberStarIcon width="18px" />
        </Box>
      )}
    </StyledMapImage>
    <Box pt="1" fontWeight="bold">
      {name}
    </Box>
  </Box>
);

BaseMapButton.defaultProps = {
  className: undefined,
  active: false,
};

export default BaseMapButton;
